<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Listado de guías del sistema
            </div>
            <div class="card-body">
                <div>
                    <div class="d-flex justify-content-end my-4">
                        <div>
                            <b-button @click="syncGuides()" class="border text-right" variant="light">
                                <i v-if="!loadingSync" class="fa fa-cloud-download mr-2" aria-hidden="true"></i>
                                <i v-else class="fa fa-spinner fa-spin mr-2"></i>
                                <span>Sincronizar listado de guías</span>
                            </b-button>
                            <!-- <p v-if="loadingSync" class="text-right">Sincronización en curso, espere unos instantes...</p> -->
                        </div>
                    </div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Nombre">Nombre guía</th>
                                <th scope="col" title="Id interno">Id interno</th>
                                <th scope="col" title="Id externo">Id externo ZT</th>
                                <th scope="col" title="Id externo usuario">Id email externo ZT</th>
                                <th scope="col" title="Status">Activo en ZT</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loadingSync">
                            <admin-guides-table-row v-for="guide in guides" :key="guide.id" :row="guide" />
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4">Actualizando el listado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AdminGuidesTableRow from './AdminGuidesTableRow.vue'
import { mapGetters } from "vuex";

export default {
    components: {
        AdminGuidesTableRow
    },
    data: function () {
        return {
            loadingSync: false,
        }
    },
    methods: {
        async syncGuides() {
            this.loadingSync = true;
            try {
                // first sync remote with bus app
                await this.$store.dispatch("guides/syncGuides")
                
                this.$notify({
                    group: "foo",
                    title: "Guías sincronizados y actualizados",
                    text: "Se han sincronizado y actualizado los guías del sistema",
                    type: "success"
                });
            } catch (ex) {
                this.loadingSync = false;
                this.error = "Failed to load data";
                this.$notify({
                    group: "foo",
                    title: "Sincronización de guías fallida",
                    text: "Ha fallado la sincronización del listado de guías",
                    type: "error"
                });
            } finally {
                this.loadingSync = false;
            }
            },
    },
    computed: {
        ...mapGetters(["guides"])
    },
    mounted() {
        this.$store.dispatch("guides/retrieveGuides")
    }
}
</script>